import React, {useState,  useEffect } from 'react';
import DeckGL from 'deck.gl';

import { renderLayers } from "./RenderLayers";

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    latitude: 9.44550291314371,
    longitude: 4.583942935103009,
    bearing: 0,
    pitch: 0,
    zoom: 3
};


function Map() {
    const [data, setData] = useState(null)
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE)


    //GeoJSONデータの読み込み
    useEffect(()=>{
        const loadGeoJSON = async ()=>{
            const res = await fetch("./data/pref.geojson")
            const json = await res.json();
            setData(json)
        }

        loadGeoJSON();
    },[])


    return (
        <div>
            <div><canvas id="test"></canvas></div>
            <DeckGL
                initialViewState={viwState}
                controller={true}
                layers={renderLayers({ data })}
                _animate={true}
                //onViewStateChange={v=>console.log(v.viewState)}
            >
            </DeckGL>
            <div id="fieldset">
                <legend>Africa NDVI Timelapse</legend>
            </div>
            <div className="attribution">
                <a
                    href="http://www.openstreetmap.org/about/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    © OpenStreetMap
                </a>
            </div>
        </div>
    );
}

export default Map;